import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes for prop type checking
import { PictureOutlined } from '@ant-design/icons';
import useStaticResources from "../../hooks/useStaticResources";
import LazyLoad from 'react-lazyload';
import {finishUrl} from "../../utils/assetUtils";

const LogoComponent = ({ src, width, height, alt, borderRadius=4, background='transparent' }) => {
  const [currentSrc, setCurrentSrc] = useState(src);
  const [errorCount, setErrorCount] = useState(0);

  useEffect(() => {
    // Reset errorCount and update source only when src changes
    if (src !== currentSrc) {
      setErrorCount(0);
      setCurrentSrc(src);
    }
  }, [src, currentSrc]);

  const handleError = () => {
    if (errorCount < 3) { // Retry up to 3 times before showing placeholder
      setErrorCount(prevCount => prevCount + 1);
      setTimeout(() => setCurrentSrc(src), 1000 * errorCount); // Exponential backoff
    } else {
      setCurrentSrc(''); // After retries, use placeholder
    }
  };

  const imageUrl = currentSrc && finishUrl(currentSrc);

  return (
    <div className='px-2'>
      {currentSrc ? (
        <img
          src={imageUrl}
          width={width}
          height={height}
          alt={alt}
          style={{ display: 'block', borderRadius, margin: 'auto', background }}
          onError={handleError}
        />
      ) : (
        <PictureOutlined style={{ fontSize: width, display: 'block', color: '#47545D' }} />
      )}
    </div>
  );
};

LogoComponent.propTypes = {
  src: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  alt: PropTypes.string,
  borderRadius: PropTypes.string,
};

LogoComponent.defaultProps = {
  width: '32px',
  height: '32px',
  alt: '',
  borderRadius: '0',
};


const Logo = React.memo(LogoComponent);

export default Logo;

